import React, { useState } from 'react';
import { NM, MN } from '../utils/constants';

/**
 * Dropdown to set the current month-end.
 * startDate: { month, year } — the forecast start date.
 * When startDate is null, falls back to index-based labels.
 */
export default function CurrentMonthSelector({ currentMonthIdx, startDate, onUpdate }) {
  const [open, setOpen] = useState(false);

  function labelFor(i) {
    if (startDate) {
      const total = startDate.month + i;
      return MN[total % 12] + ' ' + (startDate.year + Math.floor(total / 12));
    }
    return MN[i % 12] + ' Y' + (Math.floor(i / 12) + 1);
  }

  async function handleSelect(i) {
    setOpen(false);
    await onUpdate(i, startDate);
  }

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        className="action-btn secondary"
        onClick={() => setOpen(o => !o)}
        style={{ gap: 8, minWidth: 160 }}
      >
        <span style={{ fontSize: 10, color: 'var(--t3)' }}>Month-end</span>
        <span style={{ color: currentMonthIdx !== null ? 'var(--t0)' : 'var(--t3)' }}>
          {currentMonthIdx !== null ? labelFor(currentMonthIdx) : 'Not set'}
        </span>
        <span style={{ fontSize: 10, color: 'var(--t3)' }}>▾</span>
      </button>

      {open && (
        <div style={{
          position: 'absolute', top: '100%', right: 0, marginTop: 4,
          background: 'var(--s1)', border: '1px solid var(--e1)',
          borderRadius: 'var(--r2)', zIndex: 500,
          maxHeight: 260, overflowY: 'auto', minWidth: 160,
          boxShadow: '0 8px 24px rgba(0,0,0,.4)',
        }}>
          <div
            onClick={() => handleSelect(null)}
            style={{
              padding: '7px 14px', cursor: 'pointer', fontSize: 12,
              color: 'var(--t3)', borderBottom: '1px solid var(--e0)',
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'var(--s2)'}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
          >
            Not set
          </div>
          {Array.from({ length: NM }, (_, i) => (
            <div
              key={i}
              onClick={() => handleSelect(i)}
              style={{
                padding: '6px 14px', cursor: 'pointer', fontSize: 12,
                color: i === currentMonthIdx ? 'var(--blue)' : 'var(--t1)',
                background: i === currentMonthIdx ? 'var(--blue-dim)' : 'transparent',
                fontWeight: i === currentMonthIdx ? 600 : 400,
              }}
              onMouseEnter={e => { if (i !== currentMonthIdx) e.currentTarget.style.background = 'var(--s2)'; }}
              onMouseLeave={e => { if (i !== currentMonthIdx) e.currentTarget.style.background = 'transparent'; }}
            >
              {labelFor(i)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
